

import mixx from '../../../../mixin/mixin.js'


export default {
  mixins: [mixx],
  name: "tventas",
  data() {
    return {
      loading: false,
      loading_f: false,
      tbv: null,
      ventas: [], 

      f_c: { 
        fecha: this.currentdate(), 
      }

    };
  },

  mounted: function () {



    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      "autoWidth": false,
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,
    });
    $('.box').boxWidget();

  },


  computed: {
    reporte: function () {
      return (
        "/cuotacuota/simple?dsis=" + window.sssdi +
        "&fecha=" +
        this.f_c.fecha
      );
    }
  },

  methods: {
    consultar() {
      this.loading = true;

      this.tbv.clear();

      this.$http
        .post('/cuotacuota/simple',this.f_c)
        .then(response => {
          this.ventast_tabla = 0;
          if (response.data.status == 1) { 
            for (let i = 0; i < response.data.data.length; i++) {
              response.data.data[i][8] = this.num_to_many(parseFloat(response.data.data[i][8]).toFixed(2));
              response.data.data[i][9] = this.num_to_many(parseFloat(response.data.data[i][9]).toFixed(2)); 
              this.tbv.row.add(response.data.data[i]);
            }
          }
          this.tbv.draw();

          this.loading = false;
        });

    },

  }


};



// WEBPACK FOOTER //
// ./src/components/cuotaCuota/cuotaCuota/tventas/tventas.js